module.exports = __webpack_public_path__ + "static/media/depth_view.e0996ae5.png";


//////////////////
// WEBPACK FOOTER
// ./src/NDF/Implementation/img/depth_view.png
// module id = 170
// module chunks = 0